import { format, parseISO } from 'date-fns';
import SelloTiempoBitacora from "../Components/SelloTiempoBitacora";

export const COLUMNS = [
	{
		Header: 'Id BIM',
		accessor: 'idBIM',
	},
	{
		Header: 'Id SICE',
		accessor: 'idSICE',
	},
	{
		Header: 'Descripción',
		accessor: 'descripcion',
	},
	{
		Header: 'Pk Inicial',
		accessor: 'kmInicial',
	},
	{
		Header: 'Pk Final',
		accessor: 'kmFinal',
	},
	{
		Header: 'Calzada',
		accessor: 'calzada',
	},
	{
		Header: 'Acción',
		accessor: 'accion',
	},
	{
		Header: 'Fecha Creación',
		id: 'fechaCreacion',
		accessor: 'fechaCreacion',
		Cell : ({row}) => {
			if (!row.original.fechaCreacion) return '';
			try {
				return <SelloTiempoBitacora data={format(parseISO(row.original.fechaCreacion), 'dd-MM-yyyy HH:mm:ss')} />;
			} catch {
				return '';
			}
		}
	},
	{
		Header: 'Fecha Modificación',
		id: 'fechaModificacion',
		accessor: 'fechaModificacion',
		Cell : ({row}) => {
			if (!row.original.fechaModificacion) return '';
			try {
				return <SelloTiempoBitacora data={format(parseISO(row.original.fechaModificacion), 'dd-MM-yyyy HH:mm:ss')} />;
			} catch {
				return '';
			}
		}
	},
]
